import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  AdminGeneralSettingsAffiliateBannerModule,
} from '@modules/general-settings/submodules/affiliate-banner/AdminGeneralSettingsAffiliateBannerModule';
import {
  AdminGeneralSettingsAutoApproveModule,
} from '@modules/general-settings/submodules/auto-approve/AdminGeneralSettingsAutoApproveModule';
import {
  AdminGeneralSettingsBookkeepingModule,
} from '@modules/general-settings/submodules/bookkeeping/AdminGeneralSettingsBookkeepingModule';
import {
  AdminGeneralSettingsClickDomainsModule,
} from '@modules/general-settings/submodules/click-domains/AdminGeneralSettingsClickDomainsModule';
import {
  AdminGeneralSettingsEmailsModule,
} from '@modules/general-settings/submodules/emails/AdminGeneralSettingsEmailsModule';
import {
  AdminGeneralSettingsFullStatsAccessModule,
} from '@modules/general-settings/submodules/full-stats-access/AdminGeneralSettingsFullStatsAccessModule';
import {
  AdminGeneralSettingsInformationModule,
} from '@modules/general-settings/submodules/information/AdminGeneralSettingsInformationModule';
import {
  AdminGeneralSettingsNotificationsModule,
} from '@modules/general-settings/submodules/notifications/AdminGeneralSettingsNotificationsModule';
import {
  AdminGeneralSettingsProjectModule,
} from '@modules/general-settings/submodules/project-settings/AdminGeneralSettingsProjectModule';
import {
  ADMIN_GENERAL_SETTINGS_PROJECT_ROUTE_NAME,
} from '@modules/general-settings/submodules/project-settings/constants';
import {
  AdminGeneralSettingsRegistrationFieldsModule,
} from '@modules/general-settings/submodules/registration-fields/AdminGeneralSettingsRegistrationFieldsModule';
import {
  AdminGeneralSettingsTableColumnsSettingsModule,
} from '@modules/general-settings/submodules/table-columns-settings/AdminGeneralSettingsTableColumnsSettings';
import {
  AdminGeneralSettingsUploadLogoModule,
} from '@modules/general-settings/submodules/upload-logo/AdminGeneralSettingsUploadLogoModule';

import {
  ADMIN_GENERAL_SETTINGS_ROUTE_NAME,
  TRANSLATION_GROUP_GENERAL_SETTINGS,

} from './constants';
import { getTranslationKeys } from './translations';

export class AdminGeneralSettingsModule extends AppModule {
  protected submodules = [
    new AdminGeneralSettingsProjectModule(),
    new AdminGeneralSettingsRegistrationFieldsModule(),
    new AdminGeneralSettingsFullStatsAccessModule(),
    new AdminGeneralSettingsUploadLogoModule(),
    new AdminGeneralSettingsEmailsModule(),
    new AdminGeneralSettingsAutoApproveModule(),
    new AdminGeneralSettingsAffiliateBannerModule(),
    new AdminGeneralSettingsClickDomainsModule(),
    new AdminGeneralSettingsBookkeepingModule(),
    new AdminGeneralSettingsNotificationsModule(),
    new AdminGeneralSettingsInformationModule(),
    new AdminGeneralSettingsTableColumnsSettingsModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: ADMIN_GENERAL_SETTINGS_ROUTE_NAME,
      path: 'settings',
      component: () => import('./pages/AdminGeneralSettingsPage.vue'),
      redirect: { name: ADMIN_GENERAL_SETTINGS_PROJECT_ROUTE_NAME },
    });
  }

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_GENERAL_SETTINGS, getTranslationKeys);
  }
}
